/**
 * Entitlement defaults, split from Entitlement.service so that consumers of
 * the defaults (e.g. the global store reducer) don't pull the repository /
 * ApiClient stack into their module graph. Keep this module free of runtime
 * dependencies.
 */
export const ENTITLEMENT_ACCESS_CONFIG_DEFAULTS = {
  module: {
    angular: {
      dashboard: {
        expense: { enabled: false },
        order: { enabled: false },
        travel: { enabled: false },
      },
    },
    purchasing: {
      enabled: false,
    },
    expense: {
      enabled: false,
    },
    ap: {
      everythingButExpense: {
        enabled: false,
      },
      expenseAp: {
        enabled: false,
      },
    },
    contracts: {
      enabled: false,
    },
    spendingCard: {
      enabled: false,
    },
    budgets: {
      enabled: false,
    },
  },
}
